// ----------------------------------------------------------------------------
// Nombre del Programa : DetalleComunicado
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza la vista y funciones de el detalle de los comunicados
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Se agregaron funcionalidad para guardar la url de los eventos  Fecha: 26/JUN/2024
// Se agregaron funcionalidad para guardar los #  Fecha: 27/JUN/2024
// Se agregaron funcionalidad para replicar la imagen de banner  Fecha: 30/JUN/2024
// Se modificaron etiquetas 20/AGO/2024
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------


import './DetalleComunicado.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Button } from 'react-bootstrap';
import { BotonRegresar } from '../../../components/boton-regresar/BotonRegresar';
import { useEffect, useState, useRef, useMemo } from 'react';
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import useAutosizeTextArea from '../../../Utilidades/useAutosizeTextArea';
import { StatusAlertService } from 'react-status-alert';
import { ComunicadosProps } from '../../../interfaces/comunicadosInterfaces';
import { AdjuntosProps } from '../../../interfaces/adjuntosInterfaces';
import { FileUploader } from 'react-drag-drop-files';
import ReactQuill, { Quill } from 'react-quill';
import ImageEdit from 'quill-image-edit-module';
import 'quill/dist/quill.snow.css';
import { getComunicado, postComunicado } from '../../../Services/ComunicadosService';
import { postAdjunto } from '../../../Services/AdjuntosService';
import { getImgMB, getArcMB } from '../../../Utilidades/session';


var Size = Quill.import('attributors/style/size') as any;
Size.whitelist = [
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '25px',
  '30px',
  '40px',
  '50px',
];
Quill.register(Size, true);

/*var Font = Quill.import("formats/font");
Font.whitelist = ["Arial", "Serif", "Helvetica", "Frutiger", "Swift", "Futura", "Gotham", "Monospace", "Roboto", "Ubuntu", "Raleway", "Lato", "Rubik"];
Quill.register(Font, true);*/

Quill.register('modules/imageEdit', ImageEdit);
//Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste)

let quill: any = null;

export const DetalleComunicado = () => {
  const [comunicadoId, setComunicadoId] = useState(0);
  const [adjuntos, setAdjuntos] = useState<AdjuntosProps[]>([]);
  const [cargado, setCargado] = useState<boolean>(false);
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [contenido, setContenido] = useState('');
  const [fechaPublicacion, setFechaPublicacion] = useState('');
  const [fechaCierre, setFechaCierre] = useState('');
  const [urlImagenPortada, setUrlImagenPortada] = useState('');
  const [urlImagenHome, setUrlImagenHome] = useState('');
  const [urlImagenBanner, setUrlImagenBanner] = useState('');
  const [destacado, setDestacado] = useState(false);
  //Modificacion: Marca de Inicio WII C-24-1229-24
  const [palabrasclave, setPalabrasClave] = useState('');
  const [urlcalendario, setUrlCalendario] = useState('');
  //Modificacion: Marca de Fin WII C-24-1229-24

  const fileTypesImage = ['JPG', 'JPEG', 'PNG', 'GIF'];
  const [tituloAdjuntoImagen, setTituloAdjuntoImagen] = useState(
    'Seleccione/Arrastre imagen'
  );

  const params = useParams();
  let idComunicado = params.comunicadoId;

  const quillEl = useRef(null);

  useEffect(() => {
    const quillRef: any = quillEl?.current;
    if (quillRef) {
      quill = quillRef?.getEditor();
    }
  }, []);

  /*const imageHandler = async (imageDataUrl, type, imageData) => {

    const file = imageData.toFile();
    const formData = new FormData();
    formData.append('file', file);
    const quillRef: any = quillEl?.current;
    if (quillRef) {
      quill = quillRef?.getEditor();
      const response: any = await postAdjunto(formData).catch(({ response }) => {
        const { data } = response;
        StatusAlertService.showError(data.meta.message);
        return false;
      });
      if (response.data) {
        const range = quill.getSelection();
        let index = (quill.getSelection() || {}).index;
        if (index === undefined || index < 0) index = quill.getLength();
        quill.insertEmbed(
          index,
          'image',
          response.data.fileDownloadUri,
          'user'
        );
      }
    }
  }*/

  const imagenContenidoHandler = async () => {
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();
    input.onchange = async () => {
      var file: any = input && input.files ? input.files[0] : null;
      var formData = new FormData();
      formData.append('file', file);
      const quillRef: any = quillEl?.current;
      if (quillRef) {
        quill = quillRef?.getEditor();
        const response: any = await postAdjunto(formData).catch(({ response }) => {
          const { data } = response;
          StatusAlertService.showError(data.meta.message);
          return false;
        });
        if (response.data) {
          const range = quill.getSelection();
          let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
          quill.insertEmbed(
            range.index,
            'image',
            downloadUri
          );
        }
      }
    };
    /*await UploadService.uploadFile(formData)
      .then((res) => {
        let data = get(res, "data.data.url");
        const range = quillObj.getEditorSelection();
        quillObj.getEditor().insertEmbed(range.index, 'image', data);
      })
      .catch((err) => {
        message.error("This is an error message");
        return false;
      });*/
  };

  const colors = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466',
  ];

  const modul = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          //[{ font: Font.whitelist }],
          [{ font: [] }],
          [
            'bold',
            'italic',
            'underline',
            'strike',
            'blockquote',
            'link',
            'code-block',
            'image',
            { align: [] },
          ],
          [{ size: Size.whitelist }],
          [{ color: colors }, { background: colors }],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ],
        handlers: {
          image: imagenContenidoHandler,
        },
      },
      imageEdit: {
        modules: ['Resize', 'DisplaySize', 'Toolbar', 'Delete'],
      },
      clipboard: {
        matchVisual: false,
      },
    }),
    []
  );

  /*const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "link",
        "code-block",
        "image",
        { align: [] },
      ],
      [{ 'color': colors }, { 'background': colors }],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
    handlers: {
      image: imagenContenidoHandler
    },
    imageEdit: {
      modules: ["Resize", "DisplaySize", "Toolbar", "Delete"]
    }
  };*/

  const textAreaDesRef = useRef<HTMLTextAreaElement>(null);
  useAutosizeTextArea(textAreaDesRef.current, descripcion);

  const navigate = useNavigate();

  useEffect(() => {
    if (idComunicado !== '0') {
      setComunicadoId(Number(idComunicado));
      getComunicado(idComunicado!).then((response) => {
        if (response.data && response.data.data) {
          setAdjuntos(response.data.data[0].adjuntosFiles);
          setTitulo(response.data.data[0].titulo);
          setDescripcion(response.data.data[0].descripcion);
          setFechaPublicacion(
            moment(response.data.data[0].fechaPublicacion).format('YYYY-MM-DD')
          );
          if (
            response.data.data[0].fechaCierre !== '' &&
            response.data.data[0].fechaCierre !== null
          ) {
            setFechaCierre(
              moment(response.data.data[0].fechaCierre).format('YYYY-MM-DD')
            );
          }
          setUrlImagenPortada(response.data.data[0].urlImagenPortada);
          if (response.data.data[0].urlImagenBanner && response.data.data[0].destacado) {
            setUrlImagenBanner(response.data.data[0].urlImagenBanner);
          }
          if (response.data.data[0].urlImagenHome) {
            setUrlImagenHome(response.data.data[0].urlImagenHome);
          }
          setDestacado(response.data.data[0].destacado);
          setContenido(response.data.data[0].contenido);
          //Modificacion: Marca de Inicio WII C-24-1229-24
          setPalabrasClave(response.data.data[0].palabras_clave);
          setUrlCalendario(response.data.data[0].url_calendario);
          //Modificacion: Marca de Fin WII C-24-1229-24
          setCargado(true);
          /*setEditorState(EditorState.createWithContent(
            ContentState.createFromBlockArray(
              htmlToDraft(response.data.data[0].contenido)
            )));*/
        }
      });
    }
  }, []);

  const guardarAdjuntoCopiado = async (formData: FormData, imagedata: string, conte: string) => {
    const response: any = await postAdjunto(formData).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data) {
      let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
      setContenido(conte.replace(imagedata, downloadUri));
    }
  };

  const guardarAdjunto = async (file: any, tipoAdjunto: number) => {
    setCargado(false);
    let formData = new FormData();
    formData.append('file', file);
    const response: any = await postAdjunto(formData).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
      setCargado(true);
    });
    if (response.data) {
      setCargado(true);
      let downloadUri: string = response.data.fileDownloadUri.replace("null", "/api/v1/front-institucional");
      validarAdjunto(
        tipoAdjunto,
        downloadUri,
        response.data.fileName
      );
    }
  };

  const guardarComunicado = async () => {
    if (titulo === '') {
      StatusAlertService.showError('Ingrese el titulo del comunicado');
      return;
    }
    else if (descripcion === '') {
      StatusAlertService.showError('Ingrese el descripcion del comunicado');
      return;
    }
    else if (fechaPublicacion === '') {
      StatusAlertService.showError('Ingrese la fecha de publicación');
      return;
    }
    else if (urlImagenPortada === '') {
      /*else if (fechaCierre === '') {
      StatusAlertService.showError('Ingrese la fecha de cierre');
      return;
    }*/
      StatusAlertService.showError('Agregue la imagen para la vista previa (1800 * 300)');
      return;
    }
    else if (urlImagenHome === '') {
      StatusAlertService.showError('Agregue la imagen de la portada del home (800*320)');
      return;
    }
    else if (destacado && urlImagenBanner === '') {
      StatusAlertService.showError('Agregue la imagen del banner');
      return;
    }
    else if (contenido === '') {
      StatusAlertService.showError('Agregue el contenido del comunicado');
      return;
    }

    //Modificacion: Marca de Inicio WII C-24-1229-24
    if (palabrasclave != null && palabrasclave.trim() !== "") {
      var todasContienen = true;
      var primeraletra = palabrasclave.charAt(0)
      if (palabrasclave.includes("#") && primeraletra === "#") {
        var splitpalabras = palabrasclave.split(" ");
        splitpalabras.forEach((palabr) => {
          var contadorpalabr = 0;
          if (!palabr.includes("#")) {
            todasContienen = false;
          }
          //validar que no solo sean #
          var splitpalabrag = palabr.split("#");
          splitpalabrag.forEach((palabrval) => {
            if (palabrval.trim().length <= 0 && contadorpalabr > 0) {
              todasContienen = false;
            }
            contadorpalabr++;
          });
        });
      }
      else {
        todasContienen = false;
      }

      if (!todasContienen) {
        if (primeraletra !== "#") {
          StatusAlertService.showError('El campo de palabras claves debe de iniciar con # seguido de la palabra');
        }
        else {
          StatusAlertService.showError('Todas las palabras claves deben de contener # seguido de la palabra');
        }
        return;
      }
    }
    //Modificacion: Marca de Fin WII C-24-1229-24

    let comuicado = {} as ComunicadosProps;

    comuicado.comunicado_id = comunicadoId;
    comuicado.titulo = titulo;
    comuicado.descripcion = descripcion;
    comuicado.fechaPublicacion =
      moment(fechaPublicacion).format('YYYY-MM-DD') + ' 00:00:00.00';
    if (fechaCierre !== '') {
      comuicado.fechaCierre =
        moment(fechaCierre).format('YYYY-MM-DD') + ' 00:00:00.00';
    }
    //comuicado.fechaCierre = fechaCierre !== '' ? moment(fechaCierre).format("YYYY-MM-DD") + ' 00:00:00.00' : null;
    comuicado.destacado = destacado;
    comuicado.urlImagenPortada = urlImagenPortada;
    comuicado.urlImagenHome = urlImagenHome;
    comuicado.urlImagenBanner = urlImagenBanner;
    comuicado.contenido = contenido;
    comuicado.adjuntosFiles = adjuntos;
    //Modificacion: Marca de Inicio WII C-24-1229-24
    comuicado.palabras_clave = palabrasclave;
    comuicado.url_calendario = urlcalendario;
    //Modificacion: Marca de Fin WII C-24-1229-24

    //console.log('comuicado', comuicado)

    const response: any = await postComunicado(comuicado).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      navigate(-1);
    }
  };

  const handleChangeImagen = (file: any, tipoAdjunto: number) => {
    //setFile(file);
    setTituloAdjuntoImagen('Seleccionar/Arrastrar Otra');
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      guardarAdjunto(file, tipoAdjunto);
    };
    reader.onerror = function (error) {
      validarErrorAdjunto(
        tipoAdjunto,
        'Ocurrio un error al cargar el archivo...'
      );
    };
  };
  const onSizeErrorImagen = (file: any, tipoAdjunto: number) => {
    if (tipoAdjunto === 3) {
      validarErrorAdjunto(
        tipoAdjunto,
        `El tamaño del archivo debe ser menor a ${getArcMB()} mb...`
      );
    } else {
      validarErrorAdjunto(
        tipoAdjunto,
        `El tamaño del archivo debe ser menor a ${getImgMB()} mb...`
      );
    }
  };
  const onTypeErrorImagen = (file: any, tipoAdjunto: number) => {
    validarErrorAdjunto(
      tipoAdjunto,
      'El tipo de archivo que agrego no es valido...'
    );
  };

  const validarErrorAdjunto = (tipoAdjunto: number, errormensaje: string) => {
    if (tipoAdjunto === 1) {
      setUrlImagenHome('');
    }
    else if (tipoAdjunto === 2) {
      setUrlImagenBanner('');
    }
    else if (tipoAdjunto === 4) {
      setUrlImagenPortada('');
    }
    StatusAlertService.showError(errormensaje);
  };

  const validarAdjunto = (
    tipoAdjunto: number,
    urlAdjunto: string,
    nombreAdjunto: string
  ) => {
    if (tipoAdjunto === 1) {
      setUrlImagenHome(urlAdjunto);
    }
    else if (tipoAdjunto === 2) {
      setUrlImagenBanner(urlAdjunto);
    }
    else if (tipoAdjunto === 3) {
      let adjunto = {} as AdjuntosProps;
      adjunto.adjuntocomunicado_id = 0;
      adjunto.nombre = nombreAdjunto;
      adjunto.urlAdjunto = urlAdjunto;
      adjuntos.push(adjunto);
    }
    else if (tipoAdjunto === 4) {
      //Modificacion: Marca de Inicio WII C-24-1229-24
      if (urlImagenBanner == "") {
        setUrlImagenBanner(urlAdjunto);
      }
      //Modificacion: Marca de Fin WII C-24-1229-24
      setUrlImagenPortada(urlAdjunto);
    }
  };

  const abrirAdjunto = (adjunto: AdjuntosProps) => {
    window.open(adjunto.urlAdjunto, '_blank');
  };
  const borrarAdjunto = async (index: number) => {
    adjuntos.splice(index, 1);
    setAdjuntos([...adjuntos]);
    StatusAlertService.showSuccess('Borrado Exitosamente');
  };

  const onChangeContenido = (target: any) => {
    //console.log('target', target)
    //var sinimagen = target.replace('src=\"data:image\/([a-zA-Z]*);base64,([^\"]*)\"', "");
    //console.log('sinimagen', sinimagen)
    //const sources = target.match('src=\"data:image\/([a-zA-Z]*);base64,([^\"]*)\"');
    //console.log('ttttt', target.slice(target.indexOf('src="data:')).split('"'));
    const src = target.slice(target.indexOf('src="data:')).split('"')[1];
    if (src) {
      fetch(src)
        .then(res => res.blob())
        .then(blob => {
          const formData = new FormData()
          const file = new File([blob], "imagen.jpeg");
          formData.append('file', file);
          guardarAdjuntoCopiado(formData, src, target);
        });
    }
    setContenido(target);
  };

  const enterTexto = (target: any) => {
    if (target.key === 'Enter') {
      target.preventDefault();
    }
  };
  return (
    <>
      <Row className="pt-3 mb-2">
        <BotonRegresar></BotonRegresar>
      </Row>
      <div>
        <Row className="mt-3 agregar-usuario">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">
                {comunicadoId === 0
                  ? 'Nuevo comunicado'
                  : 'Editar comunicado'}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>Titulo</Form.Label>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder=""
                    aria-label="Search"
                    value={titulo}
                    maxLength={200}
                    onKeyPress={enterTexto}
                    onChange={(e) => setTitulo(e.target.value)}
                    className="borde-rojo"
                  />
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>Descripción</Form.Label>
                <Form className="d-flex">
                  <textarea
                    disabled={false}
                    onChange={(e) => setDescripcion(e.target.value)}
                    ref={textAreaDesRef}
                    rows={1}
                    value={descripcion}
                    maxLength={4000}
                    placeholder=""
                    className="textoauto borde-rojo"
                  />
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={5} className="minimocolumna">
                <Form.Label>Fecha de publicación</Form.Label>
                <Form.Control
                  type="date"
                  name="datepicd"
                  placeholder="Desde"
                  className="borde-rojo"
                  min={moment(new Date().toString()).format('YYYY-MM-DD')}
                  value={fechaPublicacion}
                  onChange={(e) => setFechaPublicacion(e.target.value)}
                />
              </Col>
              <Col sm={2}></Col>
              <Col sm={5} className="minimocolumna">
                <Form.Label>Fecha de cierre</Form.Label>
                <Form.Control
                  type="date"
                  name="datepicd"
                  placeholder="Desde"
                  className="borde-rojo"
                  min={
                    fechaPublicacion
                      ? fechaPublicacion
                      : moment(new Date().toString()).format('YYYY-MM-DD')
                  }
                  value={fechaCierre}
                  onChange={(e) => setFechaCierre(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={6} className="minimocolumna">
                <Form.Label>Imagen de portada(Home)</Form.Label>
                <FileUploader
                  label="Seleccione o arrastre imagen"
                  hoverTitle="Suelte aqui!"
                  maxSize={getImgMB()}
                  children={
                    <div className="agregar-adjunto">
                      {urlImagenHome != '' ? (
                        <img src={urlImagenHome} />
                      ) : (
                        <div className="info-agregaradjunto">
                          <span className="titulo">{tituloAdjuntoImagen}</span>
                        </div>
                      )}
                    </div>
                  }
                  handleChange={(e) => handleChangeImagen(e, 1)}
                  onTypeError={(e) => onTypeErrorImagen(e, 1)}
                  onSizeError={(e) => onSizeErrorImagen(e, 1)}
                  name="imagen_portada"
                  types={fileTypesImage}
                />
                <Form.Label>Medidas recomendadas: 800*325 px</Form.Label>
              </Col>
              <Col sm={6} className="minimocolumna">
                <Row className="d-flex">
                  <Col sm={12} className="mb-4">
                    {/*Modificacion: Marca de Inicio WII C-24-1229-24*/}
                    <Row>
                      <Col sm={2} className="mb-1">
                      </Col>
                      <Col sm={10} className="mb-2">
                        <Form.Label>Palabras claves</Form.Label>
                        <Form className="d-flex">
                          <Form.Control
                            type="search"
                            placeholder=""
                            aria-label="Search"
                            value={palabrasclave}
                            onKeyPress={enterTexto}
                            onChange={(e) => setPalabrasClave(e.target.value)}
                            className="borde-rojo"
                          />
                        </Form>
                      </Col>
                    </Row>


                    <Row>
                      <Col sm={2} className="mb-1">
                      </Col>
                      <Col sm={10} className="mb-1">
                        <Form.Label>Configura un recordatorio en tu calendario</Form.Label>
                        <Form className="d-flex">
                          <Form.Control
                            type="search"
                            placeholder=""
                            aria-label="Search"
                            value={urlcalendario}
                            onKeyPress={enterTexto}
                            onChange={(e) => setUrlCalendario(e.target.value)}
                            className="borde-rojo"
                          />
                        </Form>
                      </Col>
                    </Row>
                    {/*Modificacion: Marca de Fin WII C-24-1229-24*/}

                    <Form className="mb-3">
                      <label>
                        <input
                          className="primary checkrojo"
                          type="checkbox"
                          checked={destacado}
                          onChange={(e) => setDestacado(!destacado)}
                        />
                        Es un comunicado destacado
                      </label>
                    </Form>
                    <Form>
                      <Form.Label className="textonegro">
                        *DESTACADO:
                      </Form.Label>
                      <Form.Label>
                        Este tipo de comunicados se visualizara en el carrusel
                        de tu pagina principal.
                      </Form.Label>
                    </Form>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>Imagen vista previa</Form.Label>
                <FileUploader
                  label="Seleccione o arrastre imagen"
                  hoverTitle="Suelte aqui!"
                  maxSize={getImgMB()}
                  children={
                    <div className="agregar-adjunto">
                      {urlImagenPortada != '' ? (
                        <img src={urlImagenPortada} />
                      ) : (
                        <div className="info-agregaradjunto">
                          <span className="titulo">
                            {tituloAdjuntoImagen}
                          </span>
                        </div>
                      )}
                    </div>
                  }
                  handleChange={(e) => handleChangeImagen(e, 4)}
                  onTypeError={(e) => onTypeErrorImagen(e, 4)}
                  onSizeError={(e) => onSizeErrorImagen(e, 4)}
                  name="imagen_vistaprevia"
                  types={fileTypesImage}
                />
                <Form.Label>Medidas recomendadas: 1800*300 px</Form.Label>
              </Col>
            </Row>
            {destacado ? (
              <Row className="mt-3">
                <Col sm={12} className="minimocolumna">
                  <Form.Label>Imagen de Banner</Form.Label>
                  <FileUploader
                    label="Seleccione o arrastre imagen"
                    hoverTitle="Suelte aqui!"
                    maxSize={getImgMB()}
                    children={
                      <div className="agregar-adjunto">
                        {urlImagenBanner != '' ? (
                          <img src={urlImagenBanner} />
                        ) : (
                          <div className="info-agregaradjunto">
                            <span className="titulo">
                              {tituloAdjuntoImagen}
                            </span>
                          </div>
                        )}
                      </div>
                    }
                    handleChange={(e) => handleChangeImagen(e, 2)}
                    onTypeError={(e) => onTypeErrorImagen(e, 2)}
                    onSizeError={(e) => onSizeErrorImagen(e, 2)}
                    name="imagen_banner"
                    types={fileTypesImage}
                  />
                  <Form.Label>Medidas recomendadas: 1800*300 px</Form.Label>
                </Col>
              </Row>
            ) : (
              ''
            )}
            <Row className="titulo mt-3">
              <hr className="linearoja mt-3" />
              <Col className="heading-1">Contenido del comunicado</Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <ReactQuill
                  ref={quillEl}
                  theme="snow"
                  placeholder="Escribe tu comunicado..."
                  className="editor-class"
                  modules={modul}
                  value={contenido}
                  onChange={(e) => onChangeContenido(e)}
                //onChange={setContenido}
                />
              </Col>
            </Row>
            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <div>
                <FileUploader
                  className="float-end"
                  label="Adjuntar archivo"
                  hoverTitle="."
                  maxSize={getArcMB()}
                  children={
                    <div className="agregar-adjunto anchoadjunto">
                      <div className="info-agregaradjunto">
                        <span className="titulo">Adjuntar archivo</span>
                      </div>
                    </div>
                  }
                  handleChange={(e) => handleChangeImagen(e, 3)}
                  onTypeError={(e) => onTypeErrorImagen(e, 3)}
                  onSizeError={(e) => onSizeErrorImagen(e, 3)}
                  name="adjuntos_comunicado"
                />
              </div>
            </div>
            <Row className="mt-3">
              <Col sm={12}>
                {adjuntos.map((adj, index) => {
                  return (
                    <div key={index} className="comunicado-adjunto link">
                      <div
                        className="material-icons-outlined"
                        onClick={() => abrirAdjunto(adj)}
                      >
                        attachment
                      </div>{' '}
                      <span className="me-3" onClick={() => abrirAdjunto(adj)}>
                        {adj.nombre}
                      </span>
                      <div
                        className="material-icons-outlined"
                        onClick={() => borrarAdjunto(index)}
                      >
                        delete
                      </div>
                    </div>
                  );
                })}
              </Col>
            </Row>
            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button
                variant="primary"
                className="float-end"
                onClick={() => guardarComunicado()}
              >
                {comunicadoId === 0
                  ? 'Crear comunicado'
                  : 'Actualizar Comunicado'}
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </Button>
            </div>
          </Col>
        </Row >
      </div >
    </>
  );
};
